import Cookies from 'js-cookie'

const MARKER_COOKIE = 'auth_handoff_pending'


/**
 * Reports whether a sign-in handoff is waiting to be collected.
 *
 * Presence is the whole signal, so the value the server wrote is never read.
 *
 * @returns {Boolean} whether the handoff marker cookie is present
 */
export default function isHandoffPending() {
  return Cookies.get(MARKER_COOKIE) !== void 0
}
